export default "/_next/static/chunks/fonts/Calibri-520f77e1841983e32e9d5aa4c9a7f9fe.ttf";